import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaTiktok, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { BsWhatsapp } from 'react-icons/bs';
import styles from './styles/Footer.module.css';

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                {/* Logo Section */}
                <div className={styles.section}>
                    <img
                        src="/images/logo.jpeg"
                        alt="OV Hairstyle"
                        className={styles.footerLogo}
                    />
                    <p className={styles.brandName}>OV HAIRSTYLE</p>
                    <p className={styles.tagline}>L'expertise du salon, l'intimité de votre domicile</p>
                </div>

                {/* Navigation Section */}
                <div className={styles.section}>
                    <h4>Navigation</h4>
                    <ul>
                        <li><Link to="/">Accueil</Link></li>
                        <li><Link to="/">Services</Link></li>
                        <li><Link to="/reservation">Réservation</Link></li>
                        <li><Link to="/">Contact</Link></li>
                    </ul>
                </div>

                {/* Contact Section */}
                <div className={styles.section}>
                    <h4>Contact</h4>
                    <div className={styles.contactItem}>
                        <FaPhone className={styles.contactIcon} />
                        <p>+243 97 23 15 704</p>
                    </div>
                    <div className={styles.contactItem}>
                        <FaEnvelope className={styles.contactIcon} />
                        <p>contact@ovhairstyle.com</p>
                    </div>
                    <div className={styles.contactItem}>
                        <FaMapMarkerAlt className={styles.contactIcon} />
                        <p>Kinshasa, RD Congo</p>
                    </div>
                </div>

                {/* Social Section */}
                <div className={styles.section}>
                    <h4>Suivez-nous</h4>
                    <div className={styles.social}>
                        <a
                            href="https://facebook.com"
                            title="Facebook"
                            target="_blank"
                            rel="noreferrer"
                            className={styles.socialLink}
                        >
                            <FaFacebook />
                        </a>
                        <a
                            href="https://instagram.com"
                            title="Instagram"
                            target="_blank"
                            rel="noreferrer"
                            className={styles.socialLink}
                        >
                            <FaInstagram />
                        </a>
                        <a
                            href="https://wa.me/243972315704"
                            title="WhatsApp"
                            target="_blank"
                            rel="noreferrer"
                            className={styles.socialLink}
                        >
                            <BsWhatsapp />
                        </a>
                        <a
                            href="https://tiktok.com"
                            title="TikTok"
                            target="_blank"
                            rel="noreferrer"
                            className={styles.socialLink}
                        >
                            <FaTiktok />
                        </a>
                    </div>
                </div>
            </div>

            {/* Pages Légales */}
            <div className={styles.legal}>
                <Link to="/privacy-policy">Politique de Confidentialité</Link>
                <span className={styles.separator}>•</span>
                <Link to="/terms-of-service">Conditions d'Utilisation</Link>
            </div>

            {/* Bottom */}
            <div className={styles.bottom}>
                <p>&copy; {currentYear} OV Hairstyle. Tous droits réservés.</p>
            </div>
        </footer>
    );
}
